import React, { useEffect, useState } from 'react';
import '../style/Scan.css';
import Slider from '@mui/material/Slider';
import { Html5Qrcode, Html5QrcodeScanner } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';

const Scan = () => {
  const [value, setValue] = useState(70);
  const [scanResult, setScanResult] = useState(null);
  const navigate = useNavigate();

  const handleIncrease = () => {
    setValue(prev => Math.min(prev + 20, 100)); // Increase but max 100
  };

  const handleDecrease = () => {
    setValue(prev => Math.max(prev - 20, 0)); // Decrease but min 0
  };

  useEffect(() => {
    const readerElement = document.getElementById('reader');

    if (!readerElement) {
      console.warn('QR Code scanner container not found');
      return;
    }

    const scanner = new Html5QrcodeScanner('reader', {
      qrbox: { height: '100%', width: '100%' },
      fps: 10,
    });

    scanner.render(onScanSuccess, onScanError);

    function onScanSuccess(result, decodedResult) {
      scanner.clear();
      console.log(`QR Code scanned: ${result}`);
      setScanResult(result);
    }

    function onScanError(errorMessage) {
      console.warn(`QR Code scan error: ${errorMessage}`);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      navigate('/');
      return;
    }
  });

  return (
    <div
      className="scan-container w-100 d-flex flex-column justify-content-center align-items-center"
      style={{
        backgroundImage: 'url(/user/images/scan_bg.png)',
        height: '93dvh',
        width: '100%',
        overflowY: 'scroll',
        scrollBehavior: 'smooth',
      }}
    >
      <span className="scan-header mt-2">
        TRINGBO
        <img
          src="images/scanTringLogo.svg"
          className=""
          style={{ marginBottom: '5px' }}
        />
      </span>

      <div className="mt-3">
        {scanResult ? (
          <div>
            Success: <a href={'http://' + scanResult}>{scanResult}</a>
          </div>
        ) : (
          <div
            id="reader"
            style={{
              height: '40dvh',
              width: '300px',
              backgroundColor: 'white',
            }}
          ></div>
        )}
      </div>

      <span
        className="mt-4"
        style={{
          color: '#FFF',
          fontSize: '5.5vw',
          fontWeight: 600,
          fontFamily: 'Quicksand, sans-serif',
        }}
      >
        Scan the QR Code
      </span>

      <span
        className=""
        style={{
          color: '#C1C1C1',
          fontSize: '4.5vw',
          fontWeight: 600,
          fontFamily: 'Quicksand, sans-serif',
        }}
      >
        Play your favourite music on Tringbox
      </span>

      <div className="w-100 d-flex flex-row align-items-center justify-content-center mt-2">
        <button
          style={{ border: 'none', background: 'transparent' }}
          onClick={handleDecrease}
        >
          <img src="images/zoom-out.svg" />
        </button>

        {/* Slider */}
        <Slider
          style={{
            width: '40%',
            color: 'white',
            marginRight: '10px',
            marginLeft: '10px',
          }}
          className=""
          defaultValue={0}
          value={value} // Controlled value
          onChange={(_, newValue) => setValue(newValue)} // Update state
          aria-label="Slider"
          valueLabelDisplay="auto"
        />

        {/* Increase Button */}
        <button
          style={{ border: 'none', background: 'transparent' }}
          onClick={handleIncrease}
        >
          <img src="images/zoom-in.svg" />
        </button>
      </div>

      <div
        className="gal-flash p-2 mt-2 d-flex flex-row"
        style={{ gap: '10px', marginBottom: '10vh' }}
      >
        <button
          style={{
            border: 'none',
            backgroundColor: 'white',
            color: '#8A325D',
            fontWeight: 500,
            fontSize: '4vw',
          }}
        >
          <img src="images/gallery.svg" /> Gallery
        </button>
        <div
          style={{ border: 'solid black 1px', width: '0px' }}
          className="h-100"
        ></div>
        <button
          style={{
            border: 'none',
            backgroundColor: 'white',
            color: '#8A325D',
            fontWeight: 500,
            fontSize: '4vw',
          }}
        >
          <img src="images/flash.svg" /> Flashlight
        </button>
      </div>
    </div>
  );
};

export default Scan;
